import React from 'react';
import './SpeedControl.css';

const SpeedControl = ({ bubbleSpeed, onSpeedChange }) => {
  return (
    <div className="speed-control">
      <div className="speed-control-content">
        <label htmlFor="bubble-speed" className="speed-label">
          🐌 Bubble Frequency: {10 - bubbleSpeed}s
        </label>
        <input
          id="bubble-speed"
          type="range"
          min="1"
          max="9"
          value={bubbleSpeed}
          onChange={(e) => onSpeedChange(parseInt(e.target.value))}
          className="speed-slider"
        />
        <div className="speed-markers">
          <span>Slow</span>
          <span>Fast</span>
        </div>
      </div>
    </div>
  );
};

export default SpeedControl;

